import React, { Component } from 'react';
const pages = [
        "/",
        "/ch_consistency_t",
        "/ch_consistency_i",
        "/ch_team_rankings",
        "/ch_mvp",
        "/ch_impact_diff",
        "/ch_top_scores",
        "/ch_lineup_freq"
      ];

class TeamSelect extends Component {
  constructor(props) {
      super(props);
      this.test = this.test.bind(this);
  }
  test(event) {
    var gfilter = '';
    let page = this.props.match.params.page;
    if(page === 'ch_consistency_i' || page === 'gymnast'){
      gfilter = `/${this.props.gymnastFilter}`;
    }
    this.props.history.push(`/${page}/${this.props.yearFilter}/${event.currentTarget.value}${gfilter}`);
  }
  getTeamSelect() {
    const teams = this.props.teams.map((team) =>
      <option key={team.id} value={team.id}>{team.team_name}</option>
    );
    let page = this.props.match.params.page === undefined ? '' : this.props.match.params.page;
    if((pages.indexOf('/'+page) !== -1) || this.props.location.pathname.substr(0, 10) === '/dashboard'  || (this.props.location.pathname.substr(0, 8) === '/gymnast')){
      return <span className="medium-4 large-2 columns no-margin"><select id="team_filter" value={this.props.teamFilter} onChange={this.test}>
        <option key="0" value="0">SELECT TEAM</option>
        {teams}
        </select></span>;
    } else {
      return;
    }
  }
  render() {
    return (
      <span>
        {this.getTeamSelect()}
      </span>
    );
  }
}

export default TeamSelect;
